"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var React = require("react");
var __1 = require("../");
var recompose_1 = require("recompose");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Icon'), recompose_1.pure);
exports.Icon = enhance(function (props) {
    if (/fa-(.*)/i.test(props.className)) {
        return React.createElement(__1.FontAwesome, props);
    }
    else if (/icofont-(.*)/i.test(props.className)) {
        return React.createElement(__1.IcoFont, props);
    }
    else if (/sok-icon-(.*)/i.test(props.className)) {
        return React.createElement(__1.SokIcon, props);
    }
    else if (/file-(icon|type)-(.*)/i.test(props.className)) {
        return React.createElement(__1.FileIcon, props);
    }
    else {
        return React.createElement("span", null, "Unknown icon class");
    }
});
//# sourceMappingURL=index.js.map